module.exports = __webpack_public_path__ + "img/amazon@2x.8089cadc.png";